import {
	Activity,
	Cog,
	Database,
	Flame,
	KeyRound,
	ListChecks,
	type LucideIcon,
	Mail,
	Mic,
	Plug,
	Settings,
	ShieldCheck,
	Sparkles,
} from "lucide-react";

/** Lucide icon names a section (core or plugin-contributed) may reference. */
const SECTION_ICONS: Record<string, LucideIcon> = {
	Cog,
	Sparkles,
	Mail,
	Database,
	KeyRound,
	ListChecks,
	ShieldCheck,
	Plug,
	Flame,
	Mic,
	Activity,
	Settings,
};

/** Resolve a section's icon name to a Lucide component (Settings as the fallback). */
export function sectionIcon(name?: string): LucideIcon {
	return (name && SECTION_ICONS[name]) || Settings;
}
